module.exports = __webpack_public_path__ + "static/media/training-cover-video.640671cb.jpg";